module.exports = "/img/_/_/_/assets/images/avatar/portrait/male//elf.png?61641b0db057c7d26edfcf63aa27b9e8";